import React from 'react';
import {
  FaHandshake, FaRegMoneyBillAlt, FaChartLine, FaShieldAlt, FaReceipt,
  FaUserTag, FaUsers, FaProjectDiagram, FaClipboardCheck, FaWarehouse,
  FaFileInvoiceDollar, FaFileAlt, FaExclamationTriangle, FaGraduationCap,
  FaChalkboardTeacher, FaCalendarAlt, FaTachometerAlt,
  FaTasks, FaMapMarkedAlt, FaUserLock, FaFileMedical
} from 'react-icons/fa';
import { CiBank } from "react-icons/ci";
import { RiListIndefinite } from "react-icons/ri";
import { FaHouse } from "react-icons/fa6";
import { IoMdPerson } from "react-icons/io";
import { BiMath } from "react-icons/bi";
import {
  LuLayoutDashboard, LuCircleUser, LuUsers, LuBriefcaseBusiness, LuFolderKanban, LuHandshake,
  LuClipboardCheck, LuPackage, LuBadgeCheck, LuGraduationCap, LuWallet, LuChartColumn,
  LuSlidersHorizontal, LuLayers,
} from 'react-icons/lu';

/**
 * Portal navigation: menu tree, role requirements and per-person page grants.
 * Also read by RequireAuthorization, the menu search and Sayfa Yetkileri, so
 * keep the shape stable. Re-exported from components/SideBar for old imports.
 */

export const menuItems = [
  {
    icon: <FaTachometerAlt className="menu-icon" />,
    title: "Ana Sayfa",
    path: "/dashboard",
    submenu: [
      { title: "Yapılacaklar Listesi", path: "/todo-list", icon: <FaTasks className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "İnsan Kaynakları", "Proje Yöneticisi", "Finans Yöneticisi", "Saha Koordinatörü", "SMO Lead", "employee"]
  },
  {
    icon: <IoMdPerson className="menu-icon" />,
    title: "Profil",
    path: "/profile",
    submenu: [],
    requiredAuth: [] // Tüm kullanıcılar erişebilir
  },
  {
    icon: <FaUsers className="menu-icon" />,
    title: "Çalışan Menü",
    path: "/calisan",
    submenu: [
      { title: "Çalışan Yönetimi", path: "/employee-management", icon: <FaUsers className="submenu-icon" /> },
      { title: "Sigortalar", path: "/employee-insurance", icon: <FaShieldAlt className="submenu-icon" /> },
      { title: "İzin Yönetimi", path: "/izin-yonetimi", icon: <FaCalendarAlt className="submenu-icon" /> },
      { title: "Çalışan Hata Geribildirimleri", path: "/error-reports", icon: <FaExclamationTriangle className="submenu-icon" /> },
      { title: "Sayfa Yetkileri", path: "/sayfa-yetkileri", icon: <FaUserLock className="submenu-icon" />, requiredAuth: ["admin", "Kısıtlı Admin"] },

    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "İnsan Kaynakları", "Proje Yöneticisi", "Finans Yöneticisi"]
  },
  {
    icon: <FaUserTag className="menu-icon" />,
    title: "Müşteri Menü",
    path: "/musteri",
    submenu: [
      { title: "Müşteri Yönetimi", path: "/customer-management", icon: <FaUsers className="submenu-icon" /> },
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "Proje Yöneticisi", "Finans Yöneticisi"]
  },
  {
    icon: <FaProjectDiagram className="menu-icon" />,
    title: "Proje Menü",
    path: "/proje",
    submenu: [
      { title: "Proje Yönetimi", path: "/projects-management", icon: <FaProjectDiagram className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "Proje Yöneticisi", "Finans Yöneticisi"]
  },
  {
    icon: <FaHandshake className="menu-icon" />,
    title: "Tarife / Alt Yüklenici Menü",
    path: "/sponsor",
    submenu: [
      { title: "Alt Yüklenici / Tarife Yönetimi", path: "/sponsor-management", icon: <FaHandshake className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Finans Yöneticisi"]
  },
  {
    icon: <FaClipboardCheck className="menu-icon" />,
    title: "Operasyon Menü",
    path: "/operasyon",
    submenu: [
      { title: "Operasyon Yönetimi", path: "/operation-management", icon: <FaClipboardCheck className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "SMO Lead", "Finans Yöneticisi", "Proje Yöneticisi"]
  },
  {
    icon: <FaWarehouse className="menu-icon" />,
    title: "Stok Menü",
    path: "/stok",
    submenu: [
      { title: "Stok Yönetimi", path: "/stock-management", icon: <FaWarehouse className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "Proje Yöneticisi", "Finans Yöneticisi"]
  },
  {
    icon: <FaClipboardCheck className="menu-icon" />,
    title: "Kalite Menü",
    path: "/kalite",
    submenu: [
      { title: "Kalite Yönetimi", path: "/quality-management", icon: <FaClipboardCheck className="submenu-icon" /> },
      // Hasta sağlık verisi içerir: rol mirası yok, yalnızca admin ve Sayfa Yetkileri'nden izin verilen kişiler.
      { title: "Belge Kontrol", path: "/belge-kontrol", icon: <FaFileMedical className="submenu-icon" />, requiredAuth: ["admin"] }
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "Proje Yöneticisi", "Finans Yöneticisi"]
  },
  {
    icon: <FaGraduationCap className="menu-icon" />,
    title: "Eğitim Modülü",
    path: "/egitim",
    submenu: [
      { title: "Eğitim Yönetimi", path: "/education-management", icon: <FaChalkboardTeacher className="submenu-icon" /> },
      { title: "Eğitim Takvimi", path: "/training-calendar", icon: <FaCalendarAlt className="submenu-icon" /> },
      { title: "Eğitim Raporları", path: "/education-reports", icon: <FaFileAlt className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "Saha Koordinatörü", "Finans Yöneticisi"]
  },
  // {
  //   icon: <FaTools className="menu-icon" />,
  //   title: "TMS Menü",
  //   path: "/tms",
  //   submenu: [
  //     { title: "TMS Yönetimi", path: "/tms-yonetimi", icon: <FaTools className="submenu-icon" /> }
  //   ],
  //   requiredAuth: ["admin", "Finans Yöneticisi"]
  // },
  {
    icon: <FaFileInvoiceDollar className="menu-icon" />,
    title: "Finans Menü",
    path: "/finans",
    submenu: [
      { title: "Genel Finans Yönetimi", path: "/budget-management", icon: <FaChartLine className="submenu-icon" /> },
      { title: "Kredi & Sigorta Yönetimi", path: "/kredi-sigorta-yonetimi", icon: <FaShieldAlt className="submenu-icon" /> },
      { title: "Genel Bütçe Yönetimi", path: "/genel-butce-yonetimi", icon: <FaRegMoneyBillAlt className="submenu-icon" /> },
      { title: "Banka Hesap Tanımlama", path: "/bank-account-management", icon: <CiBank className="submenu-icon" /> },
      { title: "Maaş Ödemeleri", path: "/salary-payment", icon: <FaRegMoneyBillAlt className="submenu-icon" /> },
      { title: "Proje Finans Yönetimi", path: "/project-finance-management", icon: <FaRegMoneyBillAlt className="submenu-icon" /> },
      { title: "Çalışan Finans Yönetimi", path: "/employee-finance-management", icon: <FaRegMoneyBillAlt className="submenu-icon" /> },
      { title: "Saha Masrafları", path: "/saha-masraflari", icon: <FaReceipt className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Finans Yöneticisi"]
  },
  {
    icon: <FaFileAlt className="menu-icon" />,
    title: "Raporlar",
    path: "/raporlar",
    submenu: [
      // { title: "Hata Raporları", path: "/error-reports", icon: <FaExclamationTriangle className="submenu-icon" /> },
      { title: "SMO Lead Raporları", path: "/smo-lead-reports", icon: <FaUsers className="submenu-icon" /> },
      { title: "Bölge Müdürleri Raporları", path: "/bolge-muduru-reports", icon: <FaMapMarkedAlt className="submenu-icon" /> },
      { title: "Çalışan Raporları", path: "/employee-reports", icon: <FaFileAlt className="submenu-icon" /> },
      { title: "Çalışan Analizi", path: "/employee-analysis", icon: <FaUsers className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "Finans Yöneticisi", "SMO Lead"]
  },
  {
    icon: <RiListIndefinite className="menu-icon" />,
    title: "Tanımlamalar",
    path: "/tanimlamalar",
    submenu: [
      { title: "Merkez Yönetimi", path: "/center-management", icon: <FaHouse className="submenu-icon" /> },
      { title: "Harici Personel Yönetimi", path: "/external-personnel-management", icon: <IoMdPerson className="submenu-icon" /> },
      { title: "Veri Girişi Değerleri", path: "/data-entry-values", icon: <BiMath className="submenu-icon" /> },
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "Proje Yöneticisi", "Finans Yöneticisi"]
  }
];

// Special email-based access for specific menu sections
/**
 * "Sayfa Yetkileri" ekranı ayrıcalıklı bir sayfadır: kendisi üzerinden
 * yetki verilemez (bkz. RequireAuthorization) ki yetki yükseltme yapılamasın.
 * Bu yüzden admin rolü dışında erişebilecek kişiler yalnızca burada,
 * açıkça listelenir.
 */
export const PAGE_ACCESS_VIEWERS = [
  'hatice.alev@habcarecro.com',
  'hatice.alev@habcare.com.tr',
];

export const canViewPageAccess = (email) =>
  PAGE_ACCESS_VIEWERS.includes(String(email || '').toLowerCase());

export const SPECIAL_EMAIL_ACCESS = {
  'nagihan.cicisarac@habcarecro.com': ['/kalite', '/quality-management', '/egitim', '/education-management', '/training-calendar', '/education-reports', '/raporlar', '/smo-lead-reports'],
  'hulya.bayraktar@habcarecro.com': ['/kalite', '/quality-management', '/egitim', '/education-management', '/training-calendar', '/education-reports'],
  'arzu.dereli@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'belgin.sari@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'kubragizemcuralazakoglu@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'derya.tokyurek@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'gul.yazan@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'nisaselin.aydin@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'rumeysa.ilhan@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'sevgi.tuncay@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'fatmanur.guler@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'unzile.yetkin@habcarecro.com': ['/raporlar', '/smo-lead-reports']
};

/** Line icons for the sidebar and the menu search, keyed by top-level path. */
const MENU_ICONS = {
  '/dashboard': LuLayoutDashboard,
  '/profile': LuCircleUser,
  '/calisan': LuUsers,
  '/musteri': LuBriefcaseBusiness,
  '/proje': LuFolderKanban,
  '/sponsor': LuHandshake,
  '/operasyon': LuClipboardCheck,
  '/stok': LuPackage,
  '/kalite': LuBadgeCheck,
  '/egitim': LuGraduationCap,
  '/finans': LuWallet,
  '/raporlar': LuChartColumn,
  '/tanimlamalar': LuSlidersHorizontal,
};

export const getMenuIcon = (path) => MENU_ICONS[path] || LuLayers;

/**
 * The menu entry a route belongs to - { path, title, group, groupPath } (Turkish
 * titles; translate them by path with tMenu) - or null.
 */
export const getRouteMeta = (pathname) => {
  for (const item of menuItems) {
    const sub = item.submenu.find(
      (entry) => pathname === entry.path || pathname.startsWith(`${entry.path}/`)
    );
    if (sub) return { path: sub.path, title: sub.title, group: item.title, groupPath: item.path };
    if (pathname === item.path) return { path: item.path, title: item.title, group: null, groupPath: null };
  }
  return null;
};
